<template>
  <v-form v-model="valid" ref="mainForm">
    <div v-for="(rencontre, index) in sas.sasRencontresInspection" :key="rencontre.id">
      <v-card class="mb-3 pa-4" outlined>
        <v-card-title class="pa-0">
          Rencontre {{ index + 1 }} 
        </v-card-title>
        <ressource :code="'description-creneaux-rendezvous'" />
        <div v-if="rencontre.debutProposition1 && rencontre.finProposition1">
          <p>
            Du {{ rencontre.debutProposition1 | datetime }}
            <br />
            Au {{ rencontre.finProposition1 | datetime }}
          </p>
          <CaseACocherLive 
            code="accepter_creneau" 
            :live="liveSasRencontreInspection(33006, rencontre)" 
            v-model="rencontre.proposition1Acceptee"
            :ref="`proposition1${rencontre.id}`"
            @input="onSelectionChange(rencontre, 'proposition1', $event)"
          />
        </div>
        <div v-if="rencontre.debutProposition2 && rencontre.finProposition2">
          <p>
            Du {{ rencontre.debutProposition2 | datetime }}
            <br />
            Au {{ rencontre.finProposition2 | datetime }}
          </p>
          <CaseACocherLive 
            code="accepter_creneau" 
            :live="liveSasRencontreInspection(33009, rencontre)" 
            v-model="rencontre.proposition2Acceptee"
            :ref="`proposition2${rencontre.id}`"
            @input="onSelectionChange(rencontre, 'proposition2', $event)"
          />
        </div>
        <div v-if="rencontre.debutProposition3 && rencontre.finProposition3">
          <p>
            Du {{ rencontre.debutProposition3 | datetime }}
            <br />
            Au {{ rencontre.finProposition3 | datetime }}
          </p>
          <CaseACocherLive 
            code="accepter_creneau" 
            :live="liveSasRencontreInspection(33012, rencontre)" 
            v-model="rencontre.proposition3Acceptee"
            :ref="`proposition3${rencontre.id}`"
            @input="onSelectionChange(rencontre, 'proposition3', $event)"
          />
        </div>
        <CaseACocherLive 
          code="aucune_proposition_acceptee" 
          :live="liveSasRencontreInspection(33013, rencontre)" 
          v-model="rencontre.aucunePropositionAcceptee"
          :ref="`aucune_proposition${rencontre.id}`"
          @input="onSelectionChange(rencontre, 'aucune_proposition', $event)"
        />
        <ressource 
          :code="'aucune_proposition_acceptee'" 
          v-if="rencontre.aucunePropositionAcceptee"  
        />
      </v-card>
    </div>
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"

export default {
  mixins: [StepFormWithValidation],

  props: {
    sas: { type: Object }
  },
  computed: {
    isValid() {
      if (!this.valid) {
        return false
      }
      const result = this.sas.sasRencontresInspection.every(rencontre => {
        return this.isRencontreValid(rencontre)
      })
      return result
    }
  },
  watch: {
    "sas.sasRencontresInspection": {
      deep: true,
      handler() {
        this.$emit("validation-changed", this.isValid)
      }
    },
    valid() {
      this.$emit("validation-changed", this.isValid)
    }
  },
  methods: {
    liveSasRencontreInspection(cle, item) {
      return { endpoint: "sas-rencontre-inspection", cle: cle, fileId: item.id }
    },
    isRencontreValid(rencontre) {
      const hasPropositionAcceptee = rencontre.proposition1Acceptee || 
                                     rencontre.proposition2Acceptee || 
                                     rencontre.proposition3Acceptee ||
                                     rencontre.aucunePropositionAcceptee
      
      return hasPropositionAcceptee
    },
    onSelectionChange(rencontre, selectedRef, checked) {
      if (!checked) {
        return
      }
      const refs = ["proposition1", "proposition2", "proposition3", "aucune_proposition"]
      refs
        .filter((ref) => ref !== selectedRef)
        .forEach((ref) => {
          const caseACocher = this.$refs[`${ref}${rencontre.id}`]
          if (caseACocher && caseACocher[0]) {
            caseACocher[0].setValue(false)
          }
        })
    }
  }
}
</script>